import onDOMContentLoaded from "../base/util/dom/onDOMContentLoaded";

onDOMContentLoaded(() => {
    const USERCENTRICS_ROOT_SELECTOR = '#usercentrics-root';
    const CUSTOM_STYLES = `
        p, span, div, button, a, label, input {
            font-size: 1.6rem !important;
        }
        
        /* 
        Preserve important UI elements e.g. 
        .uc-close-button, .uc-icon {
            font-size: inherit !important;
        }
        */ 
    `;

    /**
     * Applies custom styles to an element's shadow root
     * @param element - The host element containing the shadow root
     * @returns boolean indicating success
     */
    const applyShadowRootStyles = (element: Element): boolean => {
        if (!element?.shadowRoot) {
            return false;
        }

        if (element.shadowRoot.querySelector('style[data-custom-usercentrics]')) {
            return true;
        }

        const styleBlock = document.createElement('style');
        styleBlock.textContent = CUSTOM_STYLES;
        styleBlock.setAttribute('data-custom-usercentrics', 'true');
        element.shadowRoot.appendChild(styleBlock);

        return true;
    };

    const rootElement = document.querySelector(USERCENTRICS_ROOT_SELECTOR);
    if (rootElement && applyShadowRootStyles(rootElement)) {
        return;
    }

    const observer = new MutationObserver(() => {
        const hostElement = document.querySelector(USERCENTRICS_ROOT_SELECTOR);

        if (hostElement && applyShadowRootStyles(hostElement)) {
            observer.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    window.addEventListener('beforeunload', () => {
        observer.disconnect();
    });
});